import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faCheck, faBars } from '@fortawesome/free-solid-svg-icons';

export function AmountIcon() {
  return <img src="/image/customer-area/amount-icon.png" alt="Icone de pagamento" width="31" />;
}

export function DateIcon() {
  return (
    <div style={{ position: 'relative', display: 'inline', top: '1px' }}>
      <img src="/image/customer-area/date-icon.png" alt="Icone de data" width="25" />
    </div>
  );
}

export function CardPaymentIcon() {
  return <img src="/image/customer-area/card-payment-icon.png" alt="Icone de pagamento" width="32" />;
}

export function MenuIcon({ onClick }) {
  return (
    <div onClick={onClick}>
      <FontAwesomeIcon icon={faBars} />
    </div>
  );
}

export function SpinnerIcon({ style, className }) {
  return (
    <div style={{ display: 'inline-block', ...style }} className={className}>
      <FontAwesomeIcon icon={faSpinner} className="fa-spin" style={{ width: '100%', height: '100%' }} />
    </div>
  );
}

export function CheckIcon({ style, className }) {
  return (
    <div style={{ display: 'inline-block', ...style }} className={className}>
      <FontAwesomeIcon icon={faCheck} style={{ width: '100%', height: '100%' }} />
    </div>
  );
}

export function HandMoney() {
  return <img src="/image/customer-area/amount-icon.png" alt="Icone de pagamento" width="36" />;
}

export function PixLogoIcon() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyItems: 'center',
      }}
    >
      <img
        alt="Logo do pix"
        src="/image/ic_pix_orange.png"
        style={{
          width: '100%',
          height: '100%',
          maxWidth: '100%',
          maxHeight: '100%',
        }}
      />
    </div>
  );
}

export function Tickets() {
  return <img src="/image/customer-area/tickets.png" alt="Tickets" width="32" />;
}

export function TicketsIcon({ color = '#212121' }) {
  return (
    <svg width="32" height="31" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.44213 10.0335C9.37873 9.83856 9.19702 9.70654 8.99213 9.70654C8.78724 9.70654 8.60554 9.83856 8.54213 10.0335L7.6161 12.8845H4.61798C4.41262 12.8845 4.23139 13.0165 4.16798 13.2114C4.10457 13.4064 4.17413 13.6198 4.33975 13.7405L6.76531 15.5026L5.83881 18.3531C5.7754 18.5481 5.84496 18.7619 6.01057 18.8821C6.09386 18.9427 6.19133 18.9725 6.28881 18.9725C6.38629 18.9725 6.48376 18.9427 6.56704 18.8821L8.99213 17.1205L11.4177 18.8821C11.5843 19.0033 11.8085 19.0033 11.9742 18.8821C12.1402 18.7619 12.2093 18.5481 12.1459 18.3531L11.2194 15.5026L13.6445 13.7405C13.8106 13.6198 13.8797 13.4064 13.8163 13.2114C13.7529 13.0165 13.5712 12.8845 13.3663 12.8845H10.3686L9.44213 10.0335ZM10.3847 14.9391C10.2186 15.0597 10.1495 15.2731 10.213 15.4681L10.7955 17.261L9.27037 16.1533C9.18708 16.0932 9.08961 16.0629 8.99213 16.0629C8.89465 16.0629 8.79718 16.0927 8.7139 16.1533L7.18881 17.261L7.77131 15.4681C7.83471 15.2731 7.76516 15.0597 7.59954 14.9391L6.07398 13.8308H7.95916C8.16453 13.8308 8.34576 13.6988 8.40916 13.5039L8.99118 11.711L9.57368 13.5039C9.63709 13.6988 9.81879 13.8308 10.0237 13.8308H11.9089L10.3847 14.9391Z"
        fill={color}
      />
      <path
        d="M7.09929 21.5364H5.67973C5.41806 21.5364 5.20654 21.7479 5.20654 22.0096C5.20654 22.2712 5.41806 22.4828 5.67973 22.4828H7.09929C7.36097 22.4828 7.57248 22.2712 7.57248 22.0096C7.57248 21.7479 7.36049 21.5364 7.09929 21.5364Z"
        fill={color}
      />
      <path
        d="M10.8848 21.5364H9.46522C9.20355 21.5364 8.99203 21.7479 8.99203 22.0096C8.99203 22.2712 9.20355 22.4828 9.46522 22.4828H10.8848C11.1465 22.4828 11.358 22.2712 11.358 22.0096C11.358 21.7479 11.146 21.5364 10.8848 21.5364Z"
        fill={color}
      />
      <path
        d="M12.7776 22.0096C12.7776 22.2712 12.9891 22.4828 13.2507 22.4828H14.6703C14.932 22.4828 15.1435 22.2712 15.1435 22.0096C15.1435 21.7479 14.932 21.5364 14.6703 21.5364H13.2507C12.9891 21.5364 12.7776 21.7479 12.7776 22.0096Z"
        fill={color}
      />
      <path
        d="M30.8254 5.1365L27.039 3.77939C26.7929 3.69043 26.5222 3.81867 26.4342 4.0652C25.8621 5.66174 24.0981 6.49549 22.5006 5.92293C20.9041 5.35085 20.0708 3.58633 20.6429 1.9898C20.7314 1.74374 20.6031 1.47308 20.3571 1.38459L16.5711 0.027486C16.4542 -0.0146277 16.3231 -0.0080031 16.2096 0.0449939C16.096 0.0984642 16.0085 0.194995 15.9659 0.313292L14.8047 3.5551H12.5409C12.2793 3.5551 12.0678 3.76709 12.0678 4.02829C12.0678 5.7242 10.6879 7.10401 8.99204 7.10401C7.29613 7.10401 5.91632 5.7242 5.91632 4.02829C5.91632 3.76709 5.7048 3.5551 5.44313 3.5551H1.42103C1.15936 3.5551 0.947845 3.76709 0.947845 4.02829V30.5268C0.947845 30.7885 1.15936 31 1.42103 31H5.44313C5.7048 31 5.91632 30.7885 5.91632 30.5268C5.91632 28.8309 7.29613 27.4511 8.99204 27.4511C10.6879 27.4511 12.0678 28.8309 12.0678 30.5268C12.0678 30.7885 12.2793 31 12.5409 31H16.563C16.8247 31 17.0362 30.7885 17.0362 30.5268V26.0954C17.6627 26.9069 17.8567 27.9995 17.4948 29.0102C17.4063 29.2563 17.5345 29.527 17.7806 29.615L21.5665 30.9716C21.6191 30.991 21.673 31 21.726 31C21.92 31 22.1022 30.8798 22.1713 30.6863L31.1117 5.7417C31.1543 5.62341 31.1476 5.49328 31.0942 5.37971C31.0407 5.26615 30.9437 5.17861 30.8254 5.1365ZM16.0899 30.0536H12.9862C12.7515 28.0577 11.0495 26.5047 8.99204 26.5047C6.93462 26.5047 5.23256 28.0577 4.99786 30.0536H1.89422V22.4826H3.31378C3.57546 22.4826 3.78697 22.2711 3.78697 22.0094C3.78697 21.7478 3.57546 21.5362 3.31378 21.5362H1.89422V4.50148H4.99786C5.23256 6.49738 6.93462 8.05039 8.99204 8.05039C11.0495 8.05039 12.7515 6.49738 12.9862 4.50148H16.0899V30.0536ZM21.2036 12.6039L22.9785 13.2398L21.1686 13.7684C20.9717 13.8261 20.8345 14.0036 20.8279 14.2085L20.7721 16.0922L19.7102 14.5345C19.5948 14.3651 19.3832 14.2898 19.1869 14.3471L17.3769 14.8756L18.5306 13.3842C18.656 13.2219 18.6626 12.9976 18.5471 12.8282L17.4853 11.2704L19.2602 11.9064C19.4519 11.975 19.6681 11.913 19.794 11.7502L20.9476 10.2588L20.8908 12.143C20.8842 12.3488 21.0105 12.5348 21.2036 12.6039ZM17.0362 12.293L17.5714 13.078L17.0362 13.7698V12.293ZM21.4402 29.9221L18.5187 28.8749C18.8741 27.3427 18.2949 25.7476 17.0358 24.7866V15.9616L19.1216 15.3526L20.8099 17.8293C20.8993 17.9608 21.047 18.0365 21.2008 18.0365C21.2452 18.0365 21.2897 18.0299 21.3333 18.0171C21.5301 17.9599 21.6673 17.7824 21.6739 17.5771L21.7629 14.5809L24.6408 13.7405C24.8377 13.6827 24.9749 13.5053 24.9815 13.3004C24.9877 13.0955 24.8609 12.91 24.6678 12.8409L21.8457 11.8293L21.9356 8.83257C21.9418 8.62768 21.815 8.44219 21.6219 8.3731C21.4298 8.30449 21.214 8.36648 21.0881 8.52925L19.2541 10.9009L17.0353 10.1054V4.02829C17.0353 3.76709 16.8238 3.5551 16.5621 3.5551H15.8093L16.6965 1.07844L19.6179 2.12513C19.1656 4.08318 20.2435 6.11931 22.1812 6.81347C24.1184 7.50764 26.2445 6.61994 27.1388 4.82041L30.0607 5.86757L21.4402 29.9221Z"
        fill={color}
      />
      <path
        d="M19.4136 20.1475L18.0773 19.6687C17.8312 19.5802 17.5606 19.708 17.4726 19.9545C17.3841 20.2005 17.5123 20.4712 17.7584 20.5592L19.0946 21.0381C19.1472 21.057 19.2011 21.066 19.2541 21.066C19.4481 21.066 19.6303 20.9458 19.6994 20.7523C19.7879 20.5067 19.6601 20.236 19.4136 20.1475Z"
        fill={color}
      />
      <path
        d="M22.9776 21.4253L21.6413 20.946C21.3933 20.857 21.1236 20.9852 21.0361 21.2318C20.9476 21.4783 21.0758 21.749 21.3219 21.837L22.6582 22.3163C22.7112 22.3352 22.7651 22.3442 22.8181 22.3442C23.0121 22.3442 23.1943 22.224 23.2634 22.031C23.3514 21.784 23.2236 21.5133 22.9776 21.4253Z"
        fill={color}
      />
    </svg>
  );
}

export function Phone() {
  return <img src="/image/customer-area/phone.png" alt="Tickets" width="25" />;
}

export function OrangeTicketsIcon() {
  return <img src="/image/customer-area/orange-tickets-icon.png" alt="Tickets laranja" width="72" />;
}

export function ItemsListIcon() {
  return <img src="/image/customer-area/items-list-icon.png" alt="Icone de item da lista" width="61" />;
}

export function MessageIcon() {
  return <img src="/image/customer-area/message-icon.png" alt="Icone de mensagem" width="28" />;
}

export function DoubtIcon() {
  return <img src="/image/customer-area/doubt-icon.png" alt="Icone de interrogação" width="26" />;
}

export function LeaveIcon() {
  return <img src="/image/customer-area/leave-icon.png" alt="Icone para Sair" width="20" />;
}

export function ShopIcon() {
  return <img src="/image/customer-area/shop-icon.png" alt="Icone Shop" width="33" />;
}

export function InsuranceIcon() {
  return <img src="/image/customer-area/insurance-icon.png" alt="Icone de seguro" width="31" />;
}

export function CheckBlueIcon(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx={8} cy={8} r={8} fill="#010E39" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.425 4.703a.833.833 0 0 1 0 1.178l-5.172 5.417a.833.833 0 0 1-1.179 0l-2.5-2.5a.833.833 0 1 1 1.179-1.179l1.91 1.91 4.584-4.826a.833.833 0 0 1 1.178 0Z"
        fill="#fff"
      />
    </svg>
  );
}
